interface Rule {
  src: RegExp;
  tag: RegExp;
  objects?: string[];
}

export type RuleType =
  | 'strictlyNecessaryCategory'
  | 'performanceCategory'
  | 'functionalCategory'
  | 'targetingCategory'
  | 'socialMediaCategory';

/**
 * These rules are based on the scan result from OneTrust.
 * This needs to be keep up to date over time.
 */

const rules: Record<RuleType, Record<string, Rule>> = {
  strictlyNecessaryCategory: {},
  performanceCategory: {
    amplitude: {
      src: /amplitude.com/i,
      tag: /script/i,
      objects: ['amplitude', 'amplitudeId', '__AMPLITUDE__', 'hostnameToAmplitudeId'],
    },
  },
  functionalCategory: {},
  targetingCategory: {
    googleTagManager: {
      src: /googletagmanager.com/i,
      tag: /script/i,
      objects: ['google_tag_manager', 'google_tag_manager_external'],
    },
    googleAnalytics: {
      src: /google-analytics.com/i,
      tag: /script/i,
    },
  },
  socialMediaCategory: {},
};

export default rules;
